// extracted by mini-css-extract-plugin
export default {"products":"Et-z","card":"Ft-z","oosMessaging":"Gt-z"};